import * as Sentry from "@sentry/react";
Sentry.init({
  dsn: "https://02bf31e171450a04355bf1f725c6458f@o292676.ingest.us.sentry.io/4508216434491392",
  enabled: import.meta.env.PROD,
});
